import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  TrackByFunction
} from "@angular/core";

import { Store } from "@ngxs/store";
import { TagType } from "@vp/models";
import { filterNullMap } from "@vp/shared/operators";
import * as TagManagerActions from "@vp/tag-manager/data-access/tag-manager-state";
import { TagManagerState } from "@vp/tag-manager/data-access/tag-manager-state";
import { Observable, Subject } from "rxjs";

@Component({
  selector: "vp-tag-type-menu-selector",
  standalone: false,
  templateUrl: "./tag-type-menu-selector.component.html",
  styleUrls: ["./tag-type-menu-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagTypeMenuSelectorComponent implements OnDestroy {
  filteredTagTypes$: Observable<TagType[]> = inject(Store).select(TagManagerState.tagTypes);
  selectedTagTypes$: Observable<TagType[]> = inject(Store).select(TagManagerState.selectedTagTypes);
  selectedTagType$: Observable<TagType | null> = inject(Store).select(
    TagManagerState.selectedTagType
  );

  private readonly destroy$ = new Subject<void>();
  constructor(private readonly store: Store) {}

  editingTagType$: Observable<TagType | null> = this.selectedTagType$.pipe(filterNullMap());

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  tagTypeSelected = (tagType: TagType) => {
    this.store.dispatch(new TagManagerActions.SelectTagType(tagType.tagTypeId));
    this.clearState();
  };

  removeSelected = (tagType: TagType) => {
    this.store.dispatch(new TagManagerActions.UnselectTagType(tagType.tagTypeId));
    this.clearState();
  };

  clearState() {
    this.store.dispatch(
      new TagManagerActions.UpdateState({
        tagTypeSearch: ""
      })
    );
  }

  trackTagTypeById: TrackByFunction<TagType> = (_: number, item: TagType) => item.tagTypeId;
}
